import { render, staticRenderFns } from "./newsPageStandard.vue?vue&type=template&id=38e8df7e&"
import script from "./newsPageStandard.vue?vue&type=script&lang=js&"
export * from "./newsPageStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports